export const INTERESTS = [
  "Next Chapter (flagship)",
  "Foundational Balance",
  "Executive Energy Intensive",
  "Not sure yet — just curious",
];

export const FAQ_ITEMS = [
  {
    q: "What does a health coach actually do?",
    a: "A health coach helps you turn health goals into realistic daily habits — nutrition, movement, sleep and stress — with a plan built around your real life, and support that keeps you consistent.",
  },
  {
    q: "Do you offer online sessions?",
    a: "Yes. Well&Truly is based in Dubai and works with clients in person and online, so you can join from anywhere in the world.",
  },
  {
    q: "What happens in a discovery call?",
    a: "It's a free, relaxed conversation about where you are, what you'd like to change, and whether coaching with Well&Truly is the right fit — no pressure, no obligation.",
  },
];

export const EMAIL = "hello@wellandtruly.fit";
